import { GuidEmpty } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared@models';
import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { SupportMethodsForStepsFromPlan } from 'wizards/helpers/support-methods-for-steps-from-plan';
import { HyperVFormModel } from 'wizards/models/HyperV/hyper-v-form-model';

export class HyperVModelForStepsHelper extends BaseForStepsHelper {
  public static HyperVModel: HyperVFormModel = null;

  public static HyperVModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): HyperVFormModel {
    const newPlan = plan && (plan.plan || plan.Plan);
    if (newPlan) {
      this.setThisValues(plan, settings);
      this.setStorageType(settings.mode, newPlan.ConnectionID);
      this.HyperVModel = new HyperVFormModel(this.isUnix, this.isNBF, true);

      this.updatePlanNameStep(newPlan, settings.compName);
      this.updateWhereBackupStep(newPlan, settings);

      this.HyperVModel.selectVirtualMachinesStep = StepsDataFromPlanHelper.updateSelectVirtualMachines(newPlan);
      this.HyperVModel.advancedSettingsStep = StepsDataFromPlanHelper.updateAdvancedSettingsVirtual(
        newPlan,
        this.storage,
        this.isCreate,
        false,
        settings?.agentVersion
      );
      this.HyperVModel.selectVirtualDisksStep = StepsDataFromPlanHelper.updateSelectVirtualDisks(newPlan, false);

      if (settings?.isClusterSupported && settings?.isClusterAbility) {
        this.HyperVModel.clusterStep = StepsDataFromPlanHelper.updateClusterStep(newPlan, this.isCreate);
      }

      this.bucketId = this.accounts && this.isRD ? this.getBucketId(newPlan.Bucket, newPlan.SGAccountID) : newPlan.ConnectionID;

      if (this.isNBF) {
        this.HyperVModel.appAwareStep = StepsDataFromPlanHelper.updateSelectAppAware(newPlan);
        this.HyperVModel.archiveConsistencyStep = StepsDataFromPlanHelper.updateArchiveConsistency(newPlan);
        this.HyperVModel.scheduleStep = StepsDataFromPlanHelper.updateNBFSchedule(
          newPlan,
          plan.OverdueAfterSuccess,
          this.isCreate,
          this.isUnix,
          settings.isNBF,
          settings.validVersionForSchedule
        );
        this.HyperVModel.retentionPolicyStep = StepsDataFromPlanHelper.updateNBFRetentionPolicy(
          newPlan,
          SupportMethodsForStepsFromPlan.needShowImmutability(this.storages.CloudStorages, this.bucketId),
          this.isCreate,
          this.isUnix,
          this.isNBF
        );

        if (this.nbfCanHybrid && !!newPlan.HybridConnections?.length) {
          this.HyperVModel.retentionPolicyStep = StepsDataFromPlanHelper.updateNBFHybridRetentionPolicy(
            newPlan,
            this.HyperVModel.retentionPolicyStep
          );
        }
      } else {
        this.HyperVModel.retentionPolicyStep = StepsDataFromPlanHelper.updateRetentionPolicy(
          newPlan,
          this.isCreate,
          this.planType,
          this.isUnix
        );
        this.HyperVModel.scheduleStep = StepsDataFromPlanHelper.updateSchedule(
          newPlan,
          plan.OverdueAfterSuccess,
          this.isCreate,
          this.isUnix
        );
      }

      this.HyperVModel.compressionEncryptionStep = StepsDataFromPlanHelper.updateCompressionEncryption(
        newPlan,
        this.isNBF,
        this.isUnix,
        this.isCreate,
        true
      );

      this.HyperVModel.prePostActionsStep = StepsDataFromPlanHelper.updatePrePostActions(newPlan);
      this.HyperVModel.notificationStep = StepsDataFromPlanHelper.updateNotification(newPlan.Notification);

      if (!this.isUnix) {
        this.HyperVModel.AvailableMachinePlans = StepsDataFromPlanHelper.updateAvailableMachinePlans(
          plan.AvailableMachinePlans,
          newPlan.ID
        );
      }
    }
    return this.HyperVModel;
  }

  public static updatePlanNameStep(newPlan, compName: string): void {
    const name = newPlan.Name || SupportMethodsForStepsFromPlan.generatePlanName(compName, this.planType, this.timeZoneOffset);
    this.HyperVModel.planNameStep = StepsDataFromPlanHelper.updatePlanNameStep(name, newPlan.SavePlanInCloud, this.isNBF);
  }

  public static updateWhereBackupStep(newPlan, settings: WizardHelpersSettings): void {
    if (!this.accounts) {
      this.updateWhereBackupStepData(newPlan, this.HyperVModel, settings);
    } else {
      const id = this.bucketId || this.getBucketId(newPlan.Bucket, newPlan.SGAccountID);

      this.updateWhereBackupStepData(newPlan, this.HyperVModel, settings, id);

      if (id && id !== GuidEmpty) {
        const storage = this.storages.CloudStorages.find((s) => s.ID === id) || this.storages.LocalStorages.find((s) => s.ID === id);
        this.storageType = storage ? storage.StorageType : this.storageType;
      }
    }

    if (!this.isRD) SupportMethodsForStepsFromPlan.getFilteredStoragesByTypes(this.storages, [StorageType.OpenStack]);

    this.HyperVModel.Storages = this.storages;
    this.HyperVModel.StoragesArray = [...this.storages.CloudStorages, ...this.storages.LocalStorages];
  }
}
